import React, { useEffect, useRef, useState } from "react";

import img from "../../../images/LandingPageImage/Campaign1.webp";
import img1 from "../../../images/LandingPageImage/Campaign2.webp";
import img2 from "../../../images/LandingPageImage/Campaign3.webp";
import img3 from "../../../images/LandingPageImage/Campaign4.webp";
import img4 from "../../../images/LandingPageImage/Campaign5.png";

import img5 from "../../../images/LandingPageImage/Audiance1.webp";
import img6 from "../../../images/LandingPageImage/Audiance4.webp";
import img7 from "../../../images/LandingPageImage/Audiance3.webp";
import img8 from "../../../images/LandingPageImage/Audiance6.webp";
import img9 from "../../../images/LandingPageImage/Audiance5.webp";
import img10 from "../../../images/LandingPageImage/Audiance2.webp";

import img12 from "../../../images/LandingPageImage/marketing.webp";
import img13 from "../../../images/LandingPageImage/utility.webp";
import img14 from "../../../images/LandingPageImage/authentication.webp";

import img15 from "../../../images/LandingPageImage/cart.webp";
import img16 from "../../../images/LandingPageImage/boy.webp";
import google from "../../../images/LandingPageImage/google.png";

import { useNavigate } from "react-router-dom";

const TEXT_SLIDES = [
  {
    id: 1,
    label: "Whatsapp Campaign",
    desc: "Boost your business reach with our WhatsApp Campaign feature! Connect directly with your audience through personalized messages, promotions, and updates that land straight in their chats. Drive higher engagement, increase conversions, and build lasting customer relationships effortlessly. With easy-to-use tools and real-time analytics, crafting impactful campaigns has never been simpler. Turn every message into an opportunity to grow your brand and delight your customers.",
   },
    {
    id: 2,
    label: "Audience Targeting",
    desc: "Reach the right people at the right time with precision! Our Audience Targeting feature lets you segment your contacts based on interests, behavior, location, and more, ensuring your messages resonate with those who matter most. Maximize engagement, boost conversions, and create personalized campaigns that truly connect. Say goodbye to generic blasts and hello to smarter, results-driven WhatsApp marketing!",
  },
  {
    id: 3,
    label: "Personalized Mesages",
    desc: "Give every message a value through Personalized Messages! Customize your WhatsApp promotions according to customer's name, interests, and actions, thus, building a relationship that appears sincere. Enhance participation, raise the number of replies, and transform occasional contacts into faithful customers. Our tool makes personalizing easy—connect with the appropriate person, convey the correct message, and do it at the right time every time.",
  },
  {
    id: 4,
    label: "Automated Replies & Smart Flows",
    desc: "Automated Replies & Smart Flows will surely elevate your WhatsApp Marketing! With this feature, you can easily respond to all customer inquiries, get in touch with potential customers and lead them through personalized paths. You can put up intelligent triggers, make engaging flows, and guarantee that every conversation will be timely and related. Time-saving, engagement enhancement, and auto-conversion of chats are all benefits of a 24/7 working automation that makes every interaction valuable and effective.",
  },
];

const SecondScroll = ({ slides = TEXT_SLIDES }) => {
  const [activeId, setActiveId] = useState(slides[0]?.id || 1);
  const [stackAnimationKey, setStackAnimationKey] = useState(1);
  const slideRefs = useRef([]);
const navigate = useNavigate();

const handleReadMore = (id) => {
  if (id === 1) navigate("/whatsapp-campaign");
  else if (id === 2) navigate("/audiance-targating");
  else if (id === 3) navigate("/personalized-message");
  else if (id === 4) navigate("/automated-replies");
};


  useEffect(() => {
    if (!slideRefs.current.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const slideId = Number(entry.target.dataset.id);
            setActiveId(slideId);
          }
        });
      },
      {
        root: null,
        threshold: 0.4,
        rootMargin: "0px 0px -20% 0px",
      }
    );

    slideRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      slideRefs.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
      observer.disconnect();
    };
  }, [slides]);

  useEffect(() => {
    if (activeId === 1 || activeId === 2) {
      setStackAnimationKey((k) => k + 1);
    }
  }, [activeId]);

  const renderImageContent = (id) => {
    if (id === 1) {
      return (
        <div
          key={stackAnimationKey}
          className="ss2-mobile-stack ss2-mobile-animate"
        >
          <img src={img} alt="Mobile" className="ss2-mobile-base" />
          <img
            src={img1}
            alt="Screen 1"
            className="ss2-mobile-screen ss2-screen-1"
          />
          <img
            src={img2}
            alt="Screen 2"
            className="ss2-mobile-screen ss2-screen-2"
          />
          <img
            src={img3}
            alt="Screen 3"
            className="ss2-mobile-screen ss2-screen-3"
          />
          <img
            src={img4}
            alt="Screen 4"
            className="ss2-mobile-screen ss2-screen-4"
          />
        </div>
      );
    } else if (id === 2) {
      return (
        <div
          key={stackAnimationKey}
          className="ss2-audience-stack ss2-audience-animate"
        >
          <div className="ss2-aud-center">
            <img
              src={img5}
              alt="Audience Base"
              className="ss2-aud-img"
            />
          </div>

          <div className="ss2-aud-tag">
            <img
              src={img10}
              alt="Audience Tag"
              className="ss2-aud-img"
            />
          </div>

          <div className="ss2-aud-card ss2-aud-card-6">
            <img
              src={img6}
              alt="Audience Card 6"
              className="ss2-aud-img"
            />
          </div>
          <div className="ss2-aud-card ss2-aud-card-7">
            <img
              src={img7}
              alt="Audience Card 7"
              className="ss2-aud-img"
            />
          </div>
          <div className="ss2-aud-card ss2-aud-card-8">
            <img
              src={img8}
              alt="Audience Card 8"
              className="ss2-aud-img"
            />
          </div>
          <div className="ss2-aud-card ss2-aud-card-9">
            <img
              src={img9}
              alt="Audience Card 9"
              className="ss2-aud-img"
            />
          </div>
        </div>
      );
    } else if (id === 3) {
      return (
        <div className="ss2-personal-stack ss2-personal-animate">
          <div className="ss2-per-card ss2-per-card-11">
            <img src={img12} alt="Personal 1" />
          </div>
          <div className="ss2-per-card ss2-per-card-12">
            <img src={img13} alt="Personal 2" />
          </div>
          <div className="ss2-per-card ss2-per-card-13">
            <img src={img14} alt="Personal 3" />
          </div>
        </div>
      );
    } else if (id === 4) {
      return (
        <div className="ss2-auto-stack ss2-auto-animate">
          <img
            src={img16}
            alt="Chat Boy"
            className="ss2-auto-img ss2-auto-img-15"
          />
          <img
            src={img15}
            alt="Chat Window"
            className="ss2-auto-img ss2-auto-img-14"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <style>{`
       
        .ss2-wrapper {
          width: 100%;
          background: #fff;
          padding: 5rem 2rem;
        }

        .ss2-container {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          gap: 4rem;
          align-items: flex-start;
        }

        .ss2-left {
          flex: 0.9;
          position: sticky;
          top: 150px;
        }

        .ss2-image-card {
          max-width: 600px;
          height: 600px;
          background: #e4e8eb;
          border-radius: 18px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .ss2-image {
          width: 100%;
          height: 100%;
          display: block;
          transition: opacity 0.35s ease, transform 0.35s ease;
        }

        .ss2-right {
          flex: 1.1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .ss2-slide {
          min-height: 85vh;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .ss2-label {
          font-size: 1rem;
          font-weight: 600;
          color: #9E104C;
          margin-bottom: 1rem;
          display: inline-block;
          padding: 0.3rem 0.7rem;
          border: 1.5px solid #9E104C;
          border-radius: 999px;
          text-align: left;
        }

        .ss2-desc {
          font-size: 1.2rem;
          color: #344455;
          line-height: 1.5;
          margin-bottom: 1.6rem;
          max-width: 38rem;
          text-align: left;
        }

        /* Mobile Image Card - Hidden on Desktop */
        .ss2-mobile-image-card {
          display: none;
        }

        @media (max-width: 992px) {
          .ss2-container {
            flex-direction: column;
            gap: 0;
          }

          .ss2-left {
            display: none;
          }

          .ss2-right {
            width: 100%;
          }

          .ss2-slide {
            min-height: auto;
            padding: 2rem 0;
          }

          .ss2-mobile-image-card {
            display: flex;
            width: 100%;
            height: 500px;
            background: #e4e8eb;
            border-radius: 18px;
            overflow: hidden;
            align-items: center;
            justify-content: center;
            margin-top: 1.5rem;
          }
        }

      
        .ss2-mobile-stack {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }

        .ss2-mobile-base,
        .ss2-mobile-screen {
          position: absolute;
          opacity: 0;
          transform: translateY(40px);
          box-shadow: none !important;
        }

        .ss2-mobile-base {
          position: relative;
          height: 80%;
          width: auto;
        }

        .ss2-mobile-screen {
          width: 55%;
          height: auto;
          border-radius: 14px;
        }

        .ss2-screen-1 {
          top: 32%;
          left: 4%;
        }

        .ss2-screen-2 {
          top: 55%;
          right: 4%;
        }

        .ss2-screen-3 {
          bottom: 2%;
          left: 4%;
        }

        .ss2-screen-4 {
          top: 15%;
          right: 20%;
          height: 100px;
          width: 100px;
        }

        @keyframes ss2-bottom-bounce {
          0% {
            opacity: 0;
            transform: translateY(40px);
          }
          40% {
            opacity: 1;
            transform: translateY(-14px);
          }
          60% {
            opacity: 1;
            transform: translateY(8px);
          }
          75% {
            opacity: 1;
            transform: translateY(-6px);
          }
          88% {
            opacity: 1;
            transform: translateY(3px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .ss2-mobile-animate .ss2-mobile-base {
          animation: ss2-bottom-bounce 1.8s ease-out forwards 0s;
        }

        .ss2-mobile-animate .ss2-screen-1 {
          animation: ss2-bottom-bounce 1.8s ease-out forwards 0.25s;
        }

        .ss2-mobile-animate .ss2-screen-2 {
          animation: ss2-bottom-bounce 1.8s ease-out forwards 0.5s;
        }

        .ss2-mobile-animate .ss2-screen-3 {
          animation: ss2-bottom-bounce 1.8s ease-out forwards 0.75s;
        }

        .ss2-mobile-animate .ss2-screen-4 {
          animation: ss2-bottom-bounce 1.8s ease-out forwards 1s;
        }

        

        .ss2-audience-stack {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding-top: 40px;
        }

        .ss2-aud-center {
          position: relative;
          z-index: 1;
          width: 55%;
          max-width: 300px;
          border-radius: 18px;
          overflow: hidden;
        }

        .ss2-aud-img {
          width: 100%;
          height: auto;
          display: block;
        }

        .ss2-aud-tag {
          position: absolute;
          width: 55%;
          max-width: 320px;
          border-radius: 18px;
          overflow: hidden;
          top: 25%;
          right: 18%;
          z-index: 4;
        }

        .ss2-aud-card {
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0.25);
          opacity: 0;
          width: 150px;
          height: 350px;
          max-width: 240px;
          border-radius: 16px;
          overflow: hidden;
          z-index: 2;
        }

        .ss2-aud-card-6 {
          z-index: 4;
          top: 45%;
          left: 85%;
        }

        .ss2-aud-card-7 {
          z-index: 5;
          top: 64%;
          left: 16%;
           width: 160px;
          height: 350px;
          max-width: 240px;
        }

        .ss2-aud-card-8 {
          z-index: 4;
          top: 85%;
          left: 27%;
          width: 250px;
          height: 350px;
          max-width: 240px;
        }

        .ss2-aud-card-9 {
          z-index: 2;
          top: 85%;
          left: 84%;
        }

        @keyframes ss2-card-fly {
          0% {
            opacity: 0;
            top: 55%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.25);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }

        .ss2-audience-animate .ss2-aud-card-6 {
          animation: ss2-card-fly 0.9s ease-out forwards 0.05s;
        }

        .ss2-audience-animate .ss2-aud-card-7 {
          animation: ss2-card-fly 0.9s ease-out forwards 0.2s;
        }

        .ss2-audience-animate .ss2-aud-card-8 {
          animation: ss2-card-fly 0.9s ease-out forwards 0.35s;
        }

        .ss2-audience-animate .ss2-aud-card-9 {
          animation: ss2-card-fly 0.9s ease-out forwards 0.5s;
        }

        @media (max-width: 768px) {
          .ss2-aud-center {
            width: 70%;
            max-width: 260px;
          }
          .ss2-aud-card {
            width: 50%;
            max-width: 210px;
          }
          .ss2-aud-tag {
            width: 64%;
            max-width: 210px;
            top: 6%;
            right: -4%;
          }
        }

        @media (max-width: 992px) {
          .ss2-mobile-image-card .ss2-audience-stack {
            transform: scale(0.75);
          }
          .ss2-mobile-image-card .ss2-aud-center {
            width: 100%;
            max-width: 320px;
            top: 20%;
          }
          .ss2-mobile-image-card .ss2-aud-card {
            width: 60%;
            max-width: 160px;
            height: 280px;
          }
          .ss2-mobile-image-card .ss2-aud-tag {
            width: 80%;
            max-width: 280px;
            top: 25%;
            right: -8%;
          }
          .ss2-mobile-image-card .ss2-aud-card-7 {
            width: 280px;
            height: 280px;
            top: 65%;
            left: 10%;
          }
          .ss2-mobile-image-card .ss2-aud-card-8 {
            width: 350px;
            height: 350px;
             top: 90%;
            right: -2%;
          }
        }

       

        .ss2-personal-stack {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .ss2-per-card {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 50%;
          max-width: 350px;
          height: 90%;
          max-height: 430px;
          transform: translate(-50%, 140%) scale(0.85);
          border-radius: 18px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          animation-duration: 5s;
          animation-timing-function: ease-in-out;
          animation-iteration-count: infinite;
          animation-fill-mode: forwards;
          animation-play-state: paused;
        }

        .ss2-per-card img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .ss2-personal-animate .ss2-per-card {
          animation-play-state: running;
        }

        @keyframes ss2-personal-11 {
          0% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 2;
          }
          10%, 22% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 3;
          }
          28%, 44% {
            transform: translate(-135%, -50%) scale(0.85);
            z-index: 2;
          }
          50%, 66% {
            transform: translate(35%, -50%) scale(0.85);
            z-index: 1;
          }
          70% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 4;
          }
          88% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 3;
          }
          100% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 2;
          }
        }

        @keyframes ss2-personal-12 {
          0% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 1;
          }
          12%, 28% {
            transform: translate(-135%, -50%) scale(0.85);
            z-index: 1;
          }
          34%, 50% {
            transform: translate(35%, -50%) scale(0.85);
            z-index: 1;
          }
          54% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 4;
          }
          72% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 3;
          }
          78%, 88% {
            transform: translate(-135%, -50%) scale(0.85);
            z-index: 2;
          }
          100% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 1;
          }
        }

        @keyframes ss2-personal-13 {
          0% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 1;
          }
          12%, 34% {
            transform: translate(35%, -50%) scale(0.85);
            z-index: 1;
          }
          38% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 4;
          }
          56% {
            transform: translate(-50%, -50%) scale(1);
            z-index: 3;
          }
          62%, 78% {
            transform: translate(-135%, -50%) scale(0.85);
            z-index: 2;
          }
          84%, 88% {
            transform: translate(35%, -50%) scale(0.85);
            z-index: 1;
          }
          100% {
            transform: translate(-50%, 140%) scale(0.9);
            z-index: 1;
          }
        }

        .ss2-per-card-11 {
          animation-name: ss2-personal-11;
        }
        .ss2-per-card-12 {
          animation-name: ss2-personal-12;
        }
        .ss2-per-card-13 {
          animation-name: ss2-personal-13;
        }

        @media (max-width: 768px) {
          .ss2-per-card {
            width: 68%;
            max-width: 280px;
            height: 85%;
            max-height: 430px;
          }
        }



        .ss2-auto-stack {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          overflow: visible;
        }


        .ss2-auto-img {
          position: absolute;
          opacity: 1;
          will-change: transform, bottom;   
          backface-visibility: hidden;     
          transform: translateZ(0); 
        }


        .ss2-auto-img-15 {
          right: 6%;
          bottom: -320px;
          width: 80%;
          max-width: 350px;
          z-index: 2;
        }


        .ss2-auto-img-14 {
          left: 50%;
          bottom: -360px;
          transform: translateX(-50%);
          width: 55%;
          max-width: 360px;
          z-index: 1;
        }


        @keyframes ss2-auto-15 {
          0% {
            bottom: -500px;
          }
          20% {
            bottom: 0px;
          }
            40% {
            bottom: 0px;
          }
          60% {
            bottom: 0px;
          }
          100% {
            bottom: -500px;
          }
        }


        @keyframes ss2-auto-14 {
          0% {
            bottom: -560px;
          }
          35% {
            bottom: 40px;
          }
          65% {
            bottom: 40px;
          }
          100% {
            bottom: -560px;
          }
        }


        .ss2-auto-animate .ss2-auto-img-15 {
          animation: ss2-auto-15 5s ease-in-out infinite;
        }

        .ss2-auto-animate .ss2-auto-img-14 {
          animation: ss2-auto-14 5s ease-in-out infinite;
        }


        @media (max-width: 768px) {
          .ss2-auto-img-15 {
            width: 46%;
            max-width: 220px;
          }
          .ss2-auto-img-14 {
            width: 70%;
            max-width: 260px;
          }
        }
      
        .ss2-btn-group {
  display: flex;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.ss2-btn {
  padding: 6px 12px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ss2-btn-outline {
  background: transparent;
  border: 2px solid #9E104C;
  color: #9E104C;
}

.ss2-btn-outline:hover {
  background: #9E104C;
  color: #fff;
}

.ss2-btn-primary {
  background: #9E104C;
  border: 2px solid #9E104C;
  color: #fff;
}

.ss2-btn-primary:hover {
  background: #7c0c3c;
  border-color: #7c0c3c;
}

/* Mobile center */
@media (max-width: 768px) {
  .ss2-btn-group {
    justify-content: center;
  }
}

      `}</style>

      <section className="ss2-wrapper">
        <div className="ss2-container">
          {/* Image left - Desktop Only */}
          <div className="ss2-left">
            <div className="ss2-image-card">
              {activeId === 1 ? (
                <div
                  key={stackAnimationKey}
                  className="ss2-mobile-stack ss2-mobile-animate"
                >
                  <img src={img} alt="Mobile" className="ss2-mobile-base" />

                  <img
                    src={img1}
                    alt="Screen 1"
                    className="ss2-mobile-screen ss2-screen-1"
                  />
                  <img
                    src={img2}
                    alt="Screen 2"
                    className="ss2-mobile-screen ss2-screen-2"
                  />
                  <img
                    src={img3}
                    alt="Screen 3"
                    className="ss2-mobile-screen ss2-screen-3"
                  />
                  <img
                    src={img4}
                    alt="Screen 4"
                    className="ss2-mobile-screen ss2-screen-4"
                  />
                </div>
              ) : activeId === 2 ? (
                <div
                  key={stackAnimationKey}
                  className="ss2-audience-stack ss2-audience-animate"
                >
                  <div className="ss2-aud-center">
                    <img
                      src={img5}
                      alt="Audience Base"
                      className="ss2-aud-img"
                    />
                  </div>

                  <div className="ss2-aud-tag">
                    <img
                      src={img10}
                      alt="Audience Tag"
                      className="ss2-aud-img"
                    />
                  </div>

                  <div className="ss2-aud-card ss2-aud-card-6">
                    <img
                      src={img6}
                      alt="Audience Card 6"
                      className="ss2-aud-img"
                    />
                  </div>
                  <div className="ss2-aud-card ss2-aud-card-7">
                    <img
                      src={img7}
                      alt="Audience Card 7"
                      className="ss2-aud-img"
                    />
                  </div>
                  <div className="ss2-aud-card ss2-aud-card-8">
                    <img
                      src={img8}
                      alt="Audience Card 8"
                      className="ss2-aud-img"
                    />
                  </div>
                  <div className="ss2-aud-card ss2-aud-card-9">
                    <img
                      src={img9}
                      alt="Audience Card 9"
                      className="ss2-aud-img"
                    />
                  </div>
                </div>
              ) : activeId === 3 ? (
                <div className="ss2-personal-stack ss2-personal-animate">
                  <div className="ss2-per-card ss2-per-card-11">
                    <img src={img12} alt="Personal 1" />
                  </div>
                  <div className="ss2-per-card ss2-per-card-12">
                    <img src={img13} alt="Personal 2" />
                  </div>
                  <div className="ss2-per-card ss2-per-card-13">
                    <img src={img14} alt="Personal 3" />
                  </div>
                </div>
              ) : activeId === 4 ? (
                <div className="ss2-auto-stack ss2-auto-animate">
                  {/* Boy image – bottom right fixed */}
                  <img
                    src={img16}
                    alt="Chat Boy"
                    className="ss2-auto-img ss2-auto-img-15"
                  />

                  {/* Center main image */}
                  <img
                    src={img15}
                    alt="Chat Window"
                    className="ss2-auto-img ss2-auto-img-14"
                  />
                </div>
              ) : (
                <img key={activeId} alt="Platform" className="ss2-image" />
              )}
            </div>
          </div>

          {/* Text right */}
          <div className="ss2-right">
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className="ss2-slide"
                data-id={slide.id}
                ref={(el) => (slideRefs.current[index] = el)}
              >
                <div style={{ width: '100%' }}>
                  <div className="ss2-label">{slide.label}</div>
<p className="ss2-desc">{slide.desc}</p>

<div className="ss2-btn-group">
  <button
    className="ss2-btn ss2-btn-outline"
    onClick={() => handleReadMore(slide.id)}
  >
    Read More
  </button>

  <button
    className="ss2-btn ss2-btn-primary"
    onClick={() => navigate("/login?provider=google")}
  >
    <span>Continue with</span>
                  <img
                    src={google}
                    alt="Google"
                    style={{ width: "28px", height: "28px", marginLeft: "10px" }}
                  />
  </button>
</div>
                  {/* Mobile Image Card - Only visible on mobile */}
                  <div className="ss2-mobile-image-card">
                    {renderImageContent(slide.id)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SecondScroll;